const fmt = (d) => (d ? new Date(d).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" }) : "");

export const downloadJournalPdf = async (entries, name) => {
  const { jsPDF } = await import("jspdf");
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth(), H = doc.internal.pageSize.getHeight(), M = 56, maxW = W - M * 2;
  let y = M;
  const write = (text, { size = 11, style = "normal", color = [40, 40, 40], gap = 6 } = {}) => {
    doc.setFont("helvetica", style).setFontSize(size).setTextColor(...color);
    for (const line of doc.splitTextToSize(text, maxW)) {
      if (y > H - M) { doc.addPage(); y = M; }
      doc.text(line, M, y);
      y += size * 1.4;
    }
    y += gap;
  };
  write("Heartmony · Tu diario de claridad", { size: 18, style: "bold", color: [46, 158, 91] });
  write(`${name ? `${name} · ` : ""}Descargado el ${fmt(new Date())}`, { size: 10, color: [120, 120, 120], gap: 18 });
  if (!entries.length) write("Aún no hay entradas en tu diario.");
  entries.forEach((e) => {
    const label = e.kind === "free" ? "Entrada libre" : `${e.number === 1 ? "Módulo de bienvenida" : `Módulo ${e.number}`} · ${e.title}`;
    write([label, fmt(e.saved_at)].filter(Boolean).join(" · "), { size: 10, style: "bold", color: [46, 158, 91], gap: 2 });
    if (e.insight) write(e.insight, { size: 12, style: "italic", gap: 2 });
    write(e.note || "Sin nota.", { gap: 16 });
  });
  doc.save("diario-de-claridad-heartmony.pdf");
};
